<template>
  <div
    ref="lottieContainer"
    :style="{
      width: sizeNumber + 'px',
      height: sizeNumber + 'px'
    }"
    class="lottie-icon"
  ></div>
</template>

<script>
import lottie from 'lottie-web'

// Dynamic import loaders for bundled Lottie animations
const animationLoaders = {
  'assets/lottie/coin.json': () =>
    import(/* webpackChunkName: "lottie-coin" */ '@/assets/lottie/coin.json'),
  'assets/lottie/Boxing.json': () =>
    import(
      /* webpackChunkName: "lottie-boxing" */ '@/assets/lottie/boxing.json'
    )
}

export default {
  name: 'LottieIcon',
  props: {
    src: {
      type: String,
      required: false
    },
    animationData: {
      type: Object,
      required: false
    },
    size: {
      type: [String, Number],
      default: 24
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      animation: null,
      isLoading: false
    }
  },
  computed: {
    sizeNumber() {
      return parseInt(this.size, 10)
    }
  },
  created() {
    // Validate that either src or animationData is provided
    if (!this.src && !this.animationData) {
      console.warn(
        'LottieIcon: Either src or animationData prop must be provided'
      )
    }
  },
  async mounted() {
    await this.loadAnimation()
  },
  beforeDestroy() {
    if (this.animation) {
      this.animation.destroy()
    }
  },
  methods: {
    async loadAnimation() {
      if (!this.$refs.lottieContainer) return
      if (this.isLoading) return

      this.isLoading = true

      try {
        let animationData

        // If animationData prop is provided directly, use it
        if (this.animationData) {
          animationData = this.animationData
        } else if (this.src) {
          // Check if src is a URL (starts with http/https) or local path
          if (
            this.src.startsWith('http://') ||
            this.src.startsWith('https://')
          ) {
            // External URL - use fetch
            const response = await fetch(this.src)
            animationData = await response.json()
          } else {
            // Local file - use dynamic import for better code splitting
            const loader = animationLoaders[this.src]
            if (loader) {
              const module = await loader()
              animationData = module.default
            } else {
              throw new Error(`Animation file not found: ${this.src}`)
            }
          }
        } else {
          throw new Error('No animation data or src provided')
        }

        // Load the animation
        this.animation = lottie.loadAnimation({
          container: this.$refs.lottieContainer,
          renderer: 'svg',
          loop: this.loop,
          autoplay: this.autoplay,
          animationData
        })
      } catch (error) {
        console.warn('Failed to load Lottie animation:', error)
        // Fallback to a simple icon
        this.$refs.lottieContainer.innerHTML = `
          <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: ${this
            .sizeNumber * 0.6}px;">
            ⭐
          </div>
        `
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
/* Clean styling for DotLottie component */
</style>
